<template>
  <div>
    <v-icon v-if="direction.name === 'INCOMING'" color="#d793e0" size="18" class="mr-1"
      >mdi-arrow-down</v-icon
    >
    <v-icon v-else-if="direction.name === 'OUTGOING'" color="#5caded" size="18" class="mr-1"
      >mdi-arrow-up</v-icon
    >
    <v-icon v-else size="18">mdi-arrow-right</v-icon>
    {{ direction.text }}
  </div>
</template>

<script>
export default {
  name: 'DaktelaActivityDirection',
  props: {
    direction: {
      type: Object,
      required: true,
    },
    max: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
